import {OmAveragePriceUpdateRequestDialog} from "./service/OmAveragePriceUpdateRequestDialog";
import {
    OMAveragePriceUpdateRequestDialog,
    omAveragePriceUpdateRequestDialog
} from "./component/OmAveragePriceUpdateRequestDialogComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.dialog`;

    return angular.module(moduleName, [])
                  .component(OMAveragePriceUpdateRequestDialog, omAveragePriceUpdateRequestDialog())
                  .service(OmAveragePriceUpdateRequestDialog.id, OmAveragePriceUpdateRequestDialog)
                  .name;
}
